import {
  CcfBox,
  CcfEmailIcon,
  CcfTextField,
  CcfTypography,
  CcfUpArrowIcon,
} from '@nice-ccf/ui-controls';
import styles from './ccf-copilot-crmform-control.module.scss';
import { Checkbox, InputAdornment, MenuItem, Select } from '@mui/material';
import { Info, Lightbulb, Search } from '@mui/icons-material';

/* eslint-disable-next-line */
export interface CcfCopilotCRMFormControlProps {
  label: string;
  id: string;
  value?: string;
  controlType?: string;
  menuItems?: Array<string>;
  inputSearchIcon?: boolean;
  inputEmailIcon?: boolean;
  isInputInfo?: boolean;
}

/**
 * CcfCopilot - used to display CRM Form Control
 * @param props -?-CcfCopilotCRMFormControlProps
 * @example <CcfCopilotCRMFormControl />
 */
export function CcfCopilotCRMFormControl(props: CcfCopilotCRMFormControlProps) {
  const {
    label,
    id,
    value,
    controlType,
    menuItems,
    inputSearchIcon,
    inputEmailIcon,
    isInputInfo,
  } = props;
  return (
    <CcfBox className={styles.formControl}>
      <CcfBox className={styles.labelBlock}>
        <CcfTypography className={styles.label}>{label}</CcfTypography>
      </CcfBox>
      <CcfBox className={styles.inputBlock}>
        {controlType === 'input' ? (
          <CcfTextField
            id={id}
            disabled
            fullWidth
            variant="outlined"
            size="small"
            value={value}
            focused={false}
            className={styles.inputControl}
            InputProps={{
              className: styles.inputTxt,
              endAdornment: (inputSearchIcon || inputEmailIcon) && (
                <InputAdornment position="end">
                  {inputSearchIcon && (
                    <Search className={styles.inputControlIcon} />
                  )}
                  {inputEmailIcon && (
                    <CcfEmailIcon className={styles.inputControlIcon} />
                  )}
                </InputAdornment>
              ),
            }}
          />
        ) : controlType === 'select' ? (
          <Select
            displayEmpty
            fullWidth
            disabled
            name="skill"
            variant="outlined"
            size="small"
            className={styles.inputControl}
            SelectDisplayProps={{
              style: { fontSize: '12px', color: '#333333' },
            }}
            value={value}
            IconComponent={() => (
              <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
            )}
          >
            {menuItems?.map((menu: string) => {
              return <MenuItem value={menu}>{menu}</MenuItem>;
            })}
          </Select>
        ) : (
          <Checkbox disabled style={{ padding: '0px' }} />
        )}
        {isInputInfo && (
          <CcfBox className={styles.inputInfo}>
            {id === 'account' && <Info className={styles.infoIcon} />}
            {id === 'title' && <Lightbulb className={styles.infoIcon} />}
          </CcfBox>
        )}
      </CcfBox>
    </CcfBox>
  );
}

export default CcfCopilotCRMFormControl;
